import React, { Component } from 'react'
import { Container, Row, Col, Input, Label, Button, Spinner, Card, CardBody,
  Modal, ModalHeader, ModalBody, ModalFooter, FormGroup } from 'reactstrap'
import Breadcrumbs from '../../components/Common/Breadcrumb'
import Select from '../../components/Template/Input/Select'
import DatePicker from 'react-datepicker'
import Addfiles from '../../components/Template/Files/AddFiles'
import { notifyError, notifySuccess } from '../../utils/notify'
import { graphClient } from '../../store/sagas/auth'
import DataTable from '../../components/Template/Table/DataTable'
import moment from 'moment'
import oikosApi from '../../services/oikos'

const tipos = [
  {
    label: 'Oficio',
    value: 'Oficio',
  },
  {
    label: 'Ata',
    value: 'Ata',
  },
  {
    label: 'Outro',
    value: 'Outro',
  },
]

export default class Oficios extends Component {
  constructor(props) {
    super(props)
    this.state = {
      record: {},
      formErrors: {},
      number: '',
      recipient: '',
      date: '',
      tipo: '',
      subject: '',
      body: '',
      getContractisloading: false,
      contract: [],
      contracts: null,
      oficios: null,
      signedby: '',
      getOficiosIsLoading: false,
      deleteOficiosisloading: false,
      handleSubmitisLoading: false,
      deleteRecordId: null,
      addOficioModalIsOpen: false,

    }
  }

  componentDidMount() {
    this.getContracts()
    this.oficioSolicitations()
  }

    getContracts = async () => {
      try {
        this.setState({ getContractisloading: true })
        // const siteId = 'root'
        // const listId = 'Contratos'
        // const endpoint = `sites/${siteId}/lists/${listId}/items??expand=
        // fields(select=
        // id,
        // Title,
        // C_x00f3_digodoProjeto,
        // N_x00fa_merodoContrato,
        // Servi_x00e7_os,
        // Setor_x0020_de_x0020_Atua_x00e7_,
        // Cliente,
        // TipodeCliente,
        // ValordoContrato,
        // DatadeAssinatura,
        // FimdaVig_x00ea_ncia,
        // EquipeInterna,
        // CountryOrRegion,
        // City,
        // GeoLoc,
        // Status,
        // Descritivodoacordocomercial,
        // Contato_x0020_do_x0020_Cliente,
        // Contato_x0020_do_x0020_Cliente_x,
        // Contato_x0020_do_x0020_Cliente_x0
        // )`
        // const res = await graphClient.api(endpoint).get()
        // console.tron.log('res.value getContracts', res.value)
        // this.setState({
        // getContractisloading: false,
        // contract: res.value,
        // })
        const contratos = {
          table: 'contrato',
          action: 'get',
        }
        const contracts = await oikosApi.get('/', contratos)

        console.tron.log('contracts', contracts.data)
        this.setState({
          getContractisloading: false,
          getContracts: contracts.data,
          contract: contracts.data,
        })
      } catch (e) {
        notifyError('Erro ao carregar contratos', e.toString())
        console.tron.log('Erro ao carregar contratos', e.toString())
      }
    }

    oficioSolicitations = async () => {
      try {
        this.setState({ getOficiosIsLoading: true })
        // const siteId = 'root'
        // const listId = '88d4b854-5d7a-465a-a61d-d93d140ee5bd'
        // const endpoint = `sites/${siteId}/lists/${listId}/items??expand=fields`
        // const res = await graphClient.api(endpoint).get()
        const pars = {
          table: 'oficio',
          action: 'get',
        }
        const items = await oikosApi.get('/', pars)

        console.tron.log('items', items.data)
        this.setState({
          getOficiosIsLoading: false,
          oficios: items.data,
        })
        console.tron.log('Oficios', this.oficios)
      } catch (e) {
        notifyError('Erro ao carregar ofícios.', e.toString())
        console.tron.log('Erro ao carregar ofícios.', e.toString())
      }
    }

    deleteOficioSolicitations = async (itemId) => {
      try {
        this.setState({ deleteOficiosisloading: true })

        // const siteId = 'root'
        // const listId = '88d4b854-5d7a-465a-a61d-d93d140ee5bd'
        // const endpoint = `sites/${siteId}/lists/${listId}/items/${itemId}`
        // await graphClient
        // .api(endpoint)
        // .delete()
        const pars = {
          table: 'oficio',
          action: 'delete',
          oficio_id: itemId,
        }
        const items = await oikosApi.post('/', pars)

        console.tron.log('items', items)
        this.setState({
          getOficiosIsLoading: false,
          oficioSolicitations: items.data,
        })

        notifySuccess('Registro deletado.')
        this.setState({
          deleteOficiosisloading: false,
        })
      } catch (e) {
        notifyError('Erro ao deletar ofício.', e.toString())
        console.tron.log('Erro ao deletar ofício.', e.toString())
        console.tron.log('itemId', itemId)
      }
    }

    toggleModal = () => {
      const { postOficioIsLoading } = this.setState

      if (postOficioIsLoading) return null

      this.setState(prevState => ({
        addOficioModalIsOpen: !prevState.addOficioModalIsOpen,
      }))

      return null
    }

    handleSubmit = async action => {
      try {
        this.setState({ handleSubmitisLoading: true })
        const { number, recipient, date, tipo, subject, body, contract } = this.state

        const item = {
          table: 'oficio',
          action: 'insert',
          data: {
            oficio_num: number,
            oficio_dt: moment(date).format('YYYY-MM-DD'),
            oficio_destinatario: recipient,
            oficio_assunto: subject,
            // contrato_id: contract,
            // oficio_remetente: signedby,
          },
        }
        await oikosApi.post('/', item)
        // const item = {
        // fields: {
        // Numero_x002f_ano: number,
        // DatadoDocumento: date,
        // Title: recipient,
        // Assunto: subject,
        // Corpo_x0020_do_x0020_documento: body,
        // ContratoLookupId: contract?.id,
        // TipodeDocumento: tipo.value,
        // },
        // }

        // const siteIdOficios = 'root'
        // const listIdOficios = '88d4b854-5d7a-465a-a61d-d93d140ee5bd'
        // const resoficio = await graphClient
        // .api(`/sites/${siteIdOficios}/lists/${listIdOficios}/items`)
        // .post(item)

        notifySuccess('Registro efetuado.')
        this.setState({
          handleSubmitisLoading: false,
          record: {},
        })
        console.tron.log('item', item)
        this.componentDidMount()
      } catch (e) {
        notifyError('Erro ao registrar ofício.', e.toString())
        this.setState({ handleSubmitisLoading: false,
        })
        console.tron.log('Erro ao registrar ofício.', e.toString())
      }
    }

    render() {
      const { number, recipient, date, tipo, subject, body, contract, contracts, signedby, getContractisloading,
        getOficiosisloading, oficioSolicitations, getContracts, handleSubmitisLoading, deleteRecordId, oficios, addOficioModalIsOpen } = this.state
      console.tron.log('this.state', this.state)

      return (
        <div>
          <Modal
            centered
            isOpen={addOficioModalIsOpen}
            toggle={() => this.toggleModal()}
          >
            <ModalHeader toggle={() => this.toggleModal()}>
              Novo Registro de ofícios
            </ModalHeader>
            <ModalBody>
              <FormGroup>
                <Label>Número</Label>
                <Input
                  type="number"
                  value={number}
                  onChange={number => this.setState({ number: number.target.value || null })}
                />
              </FormGroup>
              <FormGroup>
                <Label>Destinatário</Label>
                <Input
                  type="text"
                  value={recipient}
                  onChange={recipient => this.setState({ recipient: recipient.target.value || null })}
                />

              </FormGroup>
              <FormGroup>
                <Label>Data do documento</Label>
                <DatePicker
                  locale="pt-BR"
                  className="form-control"
                  maxDate={new Date()}
                  dateFormat="dd/MM/yyyy"
                  selected={date}
                  onChange={date => this.setState({
                    date,
                    dateInputError: '',
                  })}
                />
              </FormGroup>
              <FormGroup>
                <Label>Tipo de documento</Label>
                <Select
                  isClearable
                  isMulti={false}
                  placeholder="Tipo de documento"
                  options={tipos || []}
                  onChange={(tipo) => this.setState({
                    tipo,
                  })}
                />
              </FormGroup>
              <FormGroup>
                <Label>Oficio relacionado</Label>
                <Select
                  placeholder="Oficio"
                  options={[]}
                />
              </FormGroup>
              <FormGroup>
                <Label>Assunto</Label>
                <Input
                  type="text"
                  value={subject}
                  onChange={subject => this.setState({ subject: subject.target.value || null })}
                />
              </FormGroup>
              <FormGroup>
                <Label>Corpo do documento</Label>
                <Input
                  type="textarea"
                  rows={3}
                  value={body}
                  onChange={body => this.setState({ body: body.target.value || null })}
                />
              </FormGroup>
              <FormGroup>
                <Label>Contrato</Label>
                <Select
                  isSearchable
                  isClearable
                  isLoading={getContractisloading}
                  value={contracts}
                  onChange={contracts => this.setState({
                    contracts,
                  })}
                  placeholder="Contrato"
                  options={contract}
                  getOptionValue={option => option.contrato_id}
                  getOptionLabel={option => option.contrato_nome}
                />
              </FormGroup>
              <FormGroup>
                <Label>Assinado por</Label>
                <Input
                  type="text"
                  value={signedby}
                  onChange={signedby => this.setState({ signedby: signedby.target.value || null })}
                />
              </FormGroup>

            </ModalBody>
            <ModalFooter>
              <Button
                type="button"
                onClick={() => this.toggleModal()}
                color="light"
                className="waves-effect"
                disabled={oficioSolicitations}
              >
                Cancelar
              </Button>
              <Button
                type="button"
                color="primary"
                className="mt-3 waves-effect waves-light"
                onClick={() => this.handleSubmit()}
              >
                Enviar
                {handleSubmitisLoading && (
                <Spinner size="sm" className="ml-2" />
                )}
              </Button>
            </ModalFooter>
          </Modal>

          <Container fluid>
            <Row>
              <Col>
                <h4>
                  Lista de ofícios
                </h4>
              </Col>
            </Row>
            <Row>
              <Col style={{ textAlign: 'right' }}>
                <Button
                  color="primary"
                  type="button"
                  onClick={() => this.toggleModal()}
                >
                  Novo ofício
                </Button>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col>
                <Card>
                  <CardBody>
                    {getOficiosisloading && (
                      <Row>
                        <Col className="d-flex align-items-center justify-content-center py-3">
                          <Spinner size="sm" />
                        </Col>
                      </Row>
                    )}

                    {!getContracts && (
                      <DataTable
                        data={{
                          columns: [
                            {
                              label: 'Id',
                              field: 'id',
                              sort: 'disabled',
                            },
                            {
                              label: 'Número/ano',
                              field: 'number',
                              sort: 'disabled',
                            },
                            {
                              label: 'Data do documento',
                              field: 'createDt',
                              sort: 'disabled',
                            },
                            {
                              label: 'Destinatário',
                              field: 'recipient',
                              sort: 'disabled',
                            },
                            {
                              label: 'Contrato',
                              field: 'contract',
                              sort: 'disabled',
                            },
                            {
                              label: 'Assunto',
                              field: 'subject',
                              sort: 'disabled',
                            },
                            {
                              label: 'Ações',
                              field: 'actions',
                            },
                           /* {
                              label: 'Tipo',
                              field: 'tipo',
                              sort: 'disabled',
                            },*/
                          ],
                          rows: oficios.map(row => ({
                            id: row.oficio_id,
                            number: (row.oficio_num),
                            createDt: moment(row.oficio_dt).format('DD/MM/YYYY'),
                            // endDt: moment(row.fields.PrazodeAtendimentoDesejado).format('DD/MM/YYYY'),
                            subject: row.oficio_assunto,
                            // body: row.fields.Corpo_x0020_do_x0020_documento,
                            recipient: row.oficio_destinatario,
                            contract: contract?.find(t => t.contrato_id === row.contrato_id)?.contrato_nome,
                            actions: (
                              <div>
                                <Button
                                  size="sm"
                                  color="light"
                                  className="ml-2"
                                  onClick={() => this.deleteOficioSolicitations(row.oficio_id)}
                                >
                                  <i className="ri-delete-bin-6-line" />
                                </Button>
                              </div>
                            ),
                            //tipo: row.fields.TipodeDemanda,
                          })),
                        }}
                      />
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>

          </Container>
        </div>

      )
    }
}
